const DEV_HOST_SUFFIXES = [".dev.pga.com", ".dev.pgahq.com", ".m360-temp.pgahq.com"];

export const isDev = () => {
  if (typeof window === "undefined" || !window.location || !window.location.hostname) {
    return false;
  }

  const { hostname } = window.location;
  return hostname === "localhost" || DEV_HOST_SUFFIXES.some((suffix) => hostname.endsWith(suffix));
};

const getTld = () => (isDev() ? "my.dev.pga.com" : "my.pga.com");

const buildMyPgaUrl = (path: string, slug: string) => `https://${getTld()}/${path}/${slug}`;

const buildRegistrationOverrideUrl = (slug: string, eventId: string) => {
  const baseUrl = buildMyPgaUrl("member/events", slug);
  const encodedEventId = btoa(eventId);
  return `${baseUrl}?special_reg=${encodedEventId}`;
};

export const buildMemberPaymentUrl = ({
  id,
  type,
  payable
}: {
  id: string;
  type?: string | null;
  payable: boolean;
}): string | null => {
  if (!payable) {
    return null;
  }

  if (type === "education") {
    return `https://${getTld()}/member/education/purchase?orderId=${id}`;
  }

  if (type === "dues") {
    return `https://${getTld()}/member/dues`;
  }

  return `https://${getTld()}/member/account/invoices?slug=invoices`;
};

export { getTld, buildMyPgaUrl, buildRegistrationOverrideUrl };

export const openBrowser = (url: string) => {
  window.open(url);
};

export const showDevBanner = import.meta.env.MODE === "dev";

const _isMissingProtocol = (url: string) => !url.startsWith("http://") && !url.startsWith("https://");

export const ensureProtocol = (url: string, preferHttps: boolean = true) => {
  if (_isMissingProtocol(url)) {
    return preferHttps ? `https://${url}` : `http://${url}`;
  }
  return url;
};
